import { Button } from './ui/button';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import { Trophy, Zap } from 'lucide-react';

export default function PRCelebration({ open, onDismiss, movementName, value, unit }) {
  const formatValue = (v, u) => {
    if (!v && v !== 0) return '';
    const formatTime = (secs) => {
      const m = Math.floor(secs / 60);
      const s = Math.round(secs % 60);
      return `${m}:${s.toString().padStart(2, '0')}`;
    };
    if (u === 'for_time') return formatTime(v);
    if (u === 'amrap') {
      const r = Math.floor(v / 10000);
      const e = v % 10000;
      return `${r} rds + ${e} reps`;
    }
    if (u === 'seconds') {
      const mins = Math.floor(v / 60);
      const secs = Math.round(v % 60);
      return mins > 0 ? `${mins}:${secs.toString().padStart(2, '0')}` : `${secs}s`;
    }
    if (u === 'minutes') return `${v} min`;
    return `${v} ${u}`;
  };

  return (
    <Dialog open={open} onOpenChange={onDismiss}>
      <DialogContent
        className="bg-[#09090B] border-[#CCFF00]/50 max-w-sm overflow-hidden text-center"
        data-testid="pr-celebration-popup"
      >
        <DialogTitle className="sr-only">PR Smashed!</DialogTitle>
        {/* Top accent */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-[#CCFF00]" />

        <div className="pt-6 pb-2 space-y-5">
          {/* Icon */}
          <div className="flex items-center justify-center gap-2">
            <Zap className="w-5 h-5 text-[#CCFF00]/60" />
            <div className="bg-[#CCFF00]/10 border-2 border-[#CCFF00]/40 p-4 rounded-full">
              <Trophy className="w-12 h-12 text-[#CCFF00]" />
            </div>
            <Zap className="w-5 h-5 text-[#CCFF00]/60" />
          </div>

          {/* Headline */}
          <div>
            <p className="text-xs text-[#CCFF00] uppercase tracking-[0.3em] font-semibold mb-1">
              New Personal Record
            </p>
            <h2 className="text-4xl font-heading font-black uppercase text-[#FAFAFA] leading-none">
              PR Smashed!
            </h2>
          </div>

          {/* Movement + score */}
          <div className="bg-[#CCFF00]/5 border border-[#CCFF00]/20 rounded-sm py-4 px-6">
            <p className="text-sm text-[#A1A1AA] uppercase tracking-wider mb-1">{movementName}</p>
            <p className="text-4xl font-heading font-black text-[#CCFF00]">
              {formatValue(value, unit)}
            </p>
          </div>

          {/* Dismiss */}
          <div className="pt-1 px-2">
            <Button
              onClick={onDismiss}
              data-testid="pr-celebration-dismiss"
              className="w-full bg-[#CCFF00] text-[#09090B] font-bold uppercase tracking-wider hover:bg-[#b8e600] rounded-sm"
            >
              Let's Go!
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
